// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Hx-z","tooltipWrapper":"Ix-z","icon":"Jx-z","tooltip":"Kx-z","content":"Lx-z"};